/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatuserror2Inputs */

const en_crosspostingstatuserror2 = /** @type {(inputs: Crosspostingstatuserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_crosspostingstatuserror2 = /** @type {(inputs: Crosspostingstatuserror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Crosspostingstatuserror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatuserror2 = /** @type {((inputs?: Crosspostingstatuserror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatuserror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatuserror2(inputs)
	return de_crosspostingstatuserror2(inputs)
});
export { crosspostingstatuserror2 as "crosspostingStatusError" }